/**
 *  A function for combining multiple reducers into one
 * @param reducers
 * @returns updated state
 */
export const combineReducers = <T, A>(
  ...reducers: Array<(state: T, action: A) => T>
): ((state: T, action: A) => T) => {
  return (state: T, action: A): T => {
    let finalState = { ...state };
    let hasChanged = false;

    for (const reducer of reducers) {
      const newState = reducer(state, action);
      if (newState !== state) {
        finalState = { ...finalState, ...newState };
        hasChanged = true;
      }
    }

    return hasChanged ? finalState : state;
  };
};
